/* ZIEA Ginseng: variant sync, hero tabs, ritual steps, reviews, scroll-to-form. */
(() => {
  const moneyFormat = (cents, currency = "USD") => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency,
        maximumFractionDigits: 2,
      }).format(Number(cents) / 100);
    } catch (error) {
      return `$${(Number(cents) / 100).toFixed(2)}`;
    }
  };

  const setButtonLabel = (button, text) => {
    const label = button.querySelector("span");
    if (label) label.textContent = text;
  };

  const syncVariant = (select) => {
    const option = select.options[select.selectedIndex];
    const root = select.closest("[data-ziea-product-root]");
    if (!option || !root) return;
    const price = option.dataset.price;
    const available = option.dataset.available === "true";
    const currency = root.dataset.currency || "USD";
    document.querySelectorAll("[data-ziea-price]").forEach((node) => {
      if (price) node.textContent = moneyFormat(price, currency);
    });
    document.querySelectorAll("[data-ziea-add-button]").forEach((button) => {
      button.disabled = !available;
      setButtonLabel(button, available ? button.dataset.availableLabel : button.dataset.soldoutLabel);
    });
    document.querySelectorAll("[data-ziea-sticky-variant]").forEach((field) => {
      field.value = option.value;
    });
  };

  const initHeroTabs = (root) => {
    const tabs = root.querySelectorAll("[data-ziea-hero-tab]");
    const micro = root.querySelector("[data-ziea-hero-micro]");
    const heading = root.querySelector("[data-ziea-hero-heading]");
    const em = root.querySelector("[data-ziea-hero-em]");
    const lede = root.querySelector("[data-ziea-hero-lede]");
    const apply = (tab) => {
      tabs.forEach((node) => {
        const on = node === tab;
        node.classList.toggle("is-active", on);
        node.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (micro) micro.textContent = tab.dataset.micro || "";
      if (heading) heading.textContent = tab.dataset.heading || "";
      if (em) em.textContent = tab.dataset.em || "";
      if (lede) lede.textContent = tab.dataset.lede || "";
    };
    tabs.forEach((tab) => tab.addEventListener("click", () => apply(tab)));
  };

  const initRitual = (root) => {
    const steps = root.querySelectorAll("[data-ziea-ritual-step]");
    const image = root.querySelector("[data-ziea-ritual-image]");
    const marker = root.querySelector("[data-ziea-ritual-marker]");
    const caption = root.querySelector("[data-ziea-ritual-caption]");
    const apply = (index) => {
      steps.forEach((step, i) => {
        const on = i === index;
        step.classList.toggle("is-active", on);
        step.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (image) image.className = `ziea-ritual-image ziea-ritual-image--${index}`;
      const active = steps[index];
      if (active && marker) marker.textContent = active.dataset.title || "";
      if (active && caption) {
        caption.innerHTML = `<b>${active.dataset.number || ""} / ${active.dataset.title || ""}</b>${active.dataset.copy || ""}`;
      }
    };
    steps.forEach((step, i) => step.addEventListener("click", () => apply(i)));
  };

  const initReviews = (root) => {
    const cards = Array.from(root.querySelectorAll("[data-ziea-review]"));
    const prev = root.querySelector("[data-ziea-review-prev]");
    const next = root.querySelector("[data-ziea-review-next]");
    const count = cards.length;
    if (!count) return;
    let index = 0;
    const show = (nextIndex) => {
      index = (nextIndex + count) % count;
      cards.forEach((card, i) => {
        card.hidden = i !== index;
      });
    };
    if (prev) prev.addEventListener("click", () => show(index - 1));
    if (next) next.addEventListener("click", () => show(index + 1));
    show(0);
  };

  document.addEventListener("change", (event) => {
    const select = event.target.closest("[data-ziea-variant-select]");
    if (select) syncVariant(select);
  });

  const setFormError = (form, message) => {
    const wrap = form.closest("product-form")?.querySelector(".product-form__error-message-wrapper");
    const node = wrap?.querySelector(".product-form__error-message");
    if (!wrap || !node) return;
    if (message) {
      wrap.hidden = false;
      wrap.removeAttribute("hidden");
      node.textContent = message;
    } else {
      wrap.hidden = true;
      wrap.setAttribute("hidden", "");
      node.textContent = "";
    }
  };

  const restoreButton = (button) => {
    if (!button) return;
    button.disabled = false;
    button.classList.remove("loading");
    button.removeAttribute("aria-disabled");
    button.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
  };

  const addGinsengAndGoToCart = async (form) => {
    const button = form.querySelector("[data-ziea-add-button], [type='submit']");
    const idField = form.querySelector("[name='id']");
    const variantId = parseInt(String(idField?.value || ""), 10);
    const quantity = parseInt(String(form.querySelector("[name='quantity']")?.value || "1"), 10) || 1;
    setFormError(form, "");
    if (!variantId) {
      setFormError(form, "This product is missing a variant id.");
      restoreButton(button);
      return;
    }
    if (button) {
      button.setAttribute("aria-disabled", "true");
      button.classList.add("loading");
      button.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");
    }
    try {
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
      });
      const payload = await response.json();
      if (!response.ok || payload.status) {
        setFormError(form, payload.description || payload.message || "Could not add to cart.");
        restoreButton(button);
        return;
      }
      if (typeof fbq === "function") {
        const root = form.closest("[data-ziea-product-root]");
        const select = root?.querySelector("[data-ziea-variant-select]");
        const cents = Number(select?.options?.[select.selectedIndex]?.dataset?.price || payload.final_price || payload.price || 0);
        const currency = root?.dataset?.currency || "HKD";
        fbq("track", "AddToCart", {
          content_ids: [String(variantId)],
          content_type: "product",
          value: cents / 100,
          currency,
        });
      }
      window.location.href = "/cart";
    } catch (error) {
      console.error(error);
      setFormError(form, "Could not add to cart.");
      restoreButton(button);
    }
  };

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute("data-type") !== "add-to-cart-form") return;
      if (!form.closest("[data-ziea-product-root]")) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addGinsengAndGoToCart(form);
    },
    true
  );

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-ziea-scroll-product-form]");
    if (!trigger) return;
    event.preventDefault();
    const target = document.querySelector(trigger.getAttribute("href"));
    if (!target) return;
    target.scrollIntoView({
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
      block: "center",
    });
    const focusTarget = target.querySelector("select, button, input");
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  });

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-ziea-variant-select]").forEach(syncVariant);
    document.querySelectorAll("[data-ziea-hero]").forEach(initHeroTabs);
    document.querySelectorAll("[data-ziea-ritual]").forEach(initRitual);
    document.querySelectorAll("[data-ziea-reviews]").forEach(initReviews);
  });
})();
